
export enum UserAreaFilter {
  INTERCOMPANY = 'interCompany',
  AGENCY = 'agency',
  SHOWROOM = 'showroom',
  CUSTOMERCHANNEL = 'customerChannel',
  USERID = 'userId',
  SHOPVENDOR = 'shopVendorId',
}

export const AllUserAreaFilters: ReadonlyArray<UserAreaFilter> = [
  UserAreaFilter.INTERCOMPANY,
  UserAreaFilter.AGENCY,
  UserAreaFilter.SHOWROOM,
  UserAreaFilter.CUSTOMERCHANNEL,
  UserAreaFilter.USERID,
  UserAreaFilter.SHOPVENDOR
];
